// photo strip navigation
function photoStrip() {

    var $images = qSA('#hotel-photos li img'),
        imagesTotal = $images ? $images.length : 0,
        origsize = 'max800xmax194',
        largesize = (win.dataLayer[0].device == 'mobile') ? 'max480xmax480' : 'max800xmax400',
        images = [],
        carouselImages = [],
        inactiveClass = 'disabled',
        autoslideDelay = 5000,
        minimumCarouselImages = 12,
        stripPos = 0,
        sharedStorage = win.store.state,
        isRtl = sharedStorage.rtl;

    window.fallBackLazyLoad = document.createEvent('Event');
    window.fallBackLazyLoad.initEvent('doLazyLoad', true, true);

    $d.forEach($images, function($image) {
        var src = $image.getAttribute('data-src');
        images.push(src);
        var carouselUrl = src.replace(origsize, largesize).replace('/tvl/','/exp/'+largesize+'/');
        carouselImages.push(carouselUrl);
    });    

    function setStripPos($photoStrip) {
        // $photoStrip.style[isRtl ? 'right': 'left'] = -stripPos+'px';
        $photoStrip.style.transform = 'translateX('+((isRtl ? 1 : -1) * stripPos) +'px)';
    }
    function getPageWidth() {
        return Math.max(html.clientWidth, win.innerWidth || 0);
    }

    function movePhotostripRight($photoStrip, $buttons) {
        var pageWidth = getPageWidth(),
            startStripPos = stripPos,
            stripTotalWidth = function() {
                return isRtl ?
                    $photoStrip.clientWidth - $images[imagesTotal-1].offsetLeft :
                    $images[imagesTotal-1].offsetLeft + $images[imagesTotal-1].clientWidth;
            };

        stripPos += pageWidth;
        var totalWidth = stripTotalWidth();
        if (stripPos > totalWidth - pageWidth) {
            stripPos = totalWidth - pageWidth;
        } else if (stripPos < 0) {
            stripPos = 0;
        }
        setStripPos($photoStrip);
        
        win.setTimeout( function() {
            $buttons.left.classList.remove(inactiveClass);
            if (stripPos >= stripTotalWidth() - pageWidth) {
                stripPos = stripTotalWidth() - pageWidth;
                setStripPos($photoStrip);
                // $photoStrip.style.left = -stripPos+'px';
                $buttons.right.classList.add(inactiveClass);
            } else {
                $buttons.right.classList.remove(inactiveClass);
            }
            window.dispatchEvent(window.fallBackLazyLoad);

        }, 1200);
        return startStripPos != stripPos;
    }
    function resetPhotoStripPos($photoStrip, $buttons) {
        stripPos = 0;
        setStripPos($photoStrip);
        $buttons.left.classList.add(inactiveClass);
        $buttons.right.classList.remove(inactiveClass);
    }
    function movePhotostripLeft($photoStrip, $buttons) {
        var pageWidth = getPageWidth();

        stripPos = stripPos - pageWidth;
        if (stripPos < 0) stripPos = 0;
        setStripPos($photoStrip);
        
        if (stripPos >= 0) {
            $buttons.right.classList.remove(inactiveClass);
        }
        if (stripPos < 5) {
            $buttons.left.classList.add(inactiveClass);
        }

    }

    // large image

     


    win.initCarousel = function() {
        
        // Photo strip init
        var $photoStripContainer = gE('hotel-carousel-strip'),
            $photoStrip  = qS('#hotel-carousel-strip ul'),
            mouseOverStrip = false,
            carouselVisible = false;

        if (!$photoStrip) return;
        
        //$photoStrip.style[isRtl ? 'right': 'left'] = '0';
        
        var $buttons = { 
            right : $photoStripContainer.querySelector('.carousel-right'), 
            left : $photoStripContainer.querySelector('.carousel-left') 
        };

        if (!$buttons.right || !$buttons.left) return;

        $buttons.right.addEventListener('click', function() {
            movePhotostripRight($photoStrip, $buttons);
        });
        $buttons.left.addEventListener('click', function() {
            movePhotostripLeft($photoStrip, $buttons);
        });

        $photoStripContainer.addEventListener("mouseover", function() { mouseOverStrip = true; }, false);
        $photoStripContainer.addEventListener("mouseout", function() { mouseOverStrip = false; }, false);

        // auto forward thumbnails
        if (images.length > minimumCarouselImages && !win.isMobile) {
            win.setInterval( function() { 
                if (!carouselVisible && !mouseOverStrip) {
                    if (!movePhotostripRight($photoStrip, $buttons)) {
                        resetPhotoStripPos($photoStrip, $buttons);
                    }
                }
            }, autoslideDelay);
        }    
        
        var $hotelCarousel = gE('hotel-carousel-large'),
            hotelCarousel = new win.carousel($hotelCarousel, carouselImages, false ),
            showCarousel = function(index) {
                hotelCarousel.setActive(index);
                $hotelCarousel.classList.remove('hidden');
                window.setTimeout(function() {
                    document.body.classList.add('show-carousel');
                },10);
                carouselVisible = true;
            },
            hideCarousel = function() {
                document.body.classList.remove('show-carousel');
                window.setTimeout(function() {
                    $hotelCarousel.classList.add('hidden');
                }, 400);
                carouselVisible = false;
            };

        win.showCarousel = showCarousel;
        // set background color of carousel
        var $metaTheme = qS('meta[name="theme-color"]');
        var BgColor =  $metaTheme ? $metaTheme.content : '#666';
        if (BgColor == '#000000') BgColor = '#666'; // if header is black use gray
        $hotelCarousel.style.backgroundColor = BgColor;        
    

        $hotelCarousel.querySelector('.carousel-close').addEventListener('click', function(e) {
            e.stopPropagation();
            hideCarousel();
        });
                
        // open carousel events
        $d.forEach(document.querySelectorAll('#hotel-carousel-strip ul, .photo-carousel-btn'), function($link) {
            //$link.removeAttribute('onclick');

            // only add event listener for ul and photo-tab
            $link.addEventListener('click', function(event) {
                event.preventDefault();
                var $el = event.target || event.srcElement;
                var activeIndex = 0;
                if ($el.hasAttribute('src')) {
                    if (images.indexOf($el.src) !== -1) {
                        activeIndex = images.indexOf($el.src);
                    } else if ($el.hasAttribute('data-src')) {
                        activeIndex = images.indexOf($el.getAttribute('data-src'));
                    }
                }
                showCarousel(activeIndex);
            });
        });

        // init keys
        document.onkeydown = function(evt) {
            if (carouselVisible) {
                evt = evt || win.event;
                if (evt.keyCode == 39) {
                   hotelCarousel.next(); 
                }
                if (evt.keyCode == 37) {
                   hotelCarousel.previous(); 
                }
                if(evt.keyCode === 27) {
                    hideCarousel();
                }
            }
        };

        // check if carousel needs to be centered and if arrow buttons are needed
        function maybeSetCarouselNoScroll() {
            if (this.tagName == 'IMG') this.classList.remove('loading');
            if (!$photoStrip.querySelector('img.loading')) {
                var lastImgPos = $photoStrip.querySelector('li:last-child img').getBoundingClientRect(),
                    carouselWidth = lastImgPos.left + lastImgPos.width;
                if (carouselWidth  < getPageWidth()) {
                    document.body.classList.add('carousel-no-scroll');
                } 
            }
        }
        if (images.length < minimumCarouselImages) {
            $d.forEach($photoStrip.querySelectorAll('img'), function($img) {
                var allComplete = true;
                if (!$img.complete) {
                    $img.classList.add('loading');
                    $img.onload = maybeSetCarouselNoScroll;
                    allComplete = false;
                }
                if (allComplete) maybeSetCarouselNoScroll();
            });
        }

    };


    if (gE("hotel-photos") && images && !win.disableCarousel) { //!photoSitelink && 
        win.lazyLoadInit({ root: qS('#hotel-carousel-strip .hotel-preload-viewport') }, "lazy-crsl");
        win.initCarousel();
    }

    // if sitelink is used show the carousel
    if (sharedStorage.siteLink == 'hotelPhotos') {
        showCarousel(0);
    }

}

win.photoStrip();